import { Button } from "@/components/ui/button";
import { BellRinging, BellSlash } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useWebPush } from "@/hooks/useWebPush";

export default function PushToggle({ className = "" }) {
  const { supported, subscribed, busy, enable, disable } = useWebPush();
  if (!supported) return null;

  const toggle = async () => {
    if (subscribed) {
      await disable();
      toast.success("Notifications push désactivées");
      return;
    }
    const res = await enable();
    if (res.ok) toast.success("Notifications push activées");
    else if (res.reason === "denied") toast.error("Notifications refusées par le navigateur");
    else toast.error("Impossible d'activer les notifications push");
  };

  return (
    <Button
      data-testid="push-toggle"
      variant="outline"
      size="sm"
      onClick={toggle}
      disabled={busy}
      className={`${subscribed ? "border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10" : "border-zinc-700 text-zinc-300 hover:bg-zinc-800"} h-9 ${className}`}
    >
      {subscribed ? <BellRinging size={14} weight="fill" className="mr-1.5" /> : <BellSlash size={14} className="mr-1.5" />}
      {busy ? "..." : subscribed ? "Push activé" : "Activer les notifications push"}
    </Button>
  );
}
